import { ASSETS } from './assets-data'

const ThankYouData = {
    en: {
        seo: {
            title: 'Thank You | Tropical Marine Construction',
            description: 'Your message has been received. Tropical Marine Construction will be in touch shortly to discuss your dock or boat lift project.',
            keywords: 'Tropical Marine Construction, Cape Coral, contact confirmation'
        },
        heroBg: ASSETS.DOCKS_1 || '',
        title: 'THANK YOU!',
        subtitle: 'Your message has been received. We will get back to you promptly to discuss your project.',

        nextStepsTitle: 'What Happens Next',
        nextStepsBody: 'Our team will review your inquiry and reach out to schedule a consultation. We provide free, written estimates for all dock construction, boat lift, repair, and maintenance projects in Cape Coral and Lee County.',

        meanwhile: 'While You Wait',
        galleryBtn: 'View Our Photo Gallery',
        homeBtn: 'Back to Home',

        projectsTitle: 'Our Marine Construction Services',
        projectsSub: 'Dock Construction, Boat Lift Installation, Repair, Maintenance, and Tiki Huts throughout SWFL.'
    },

    he: {
        seo: {
            title: 'Thank You | Tropical Marine Construction',
            description: 'Your message has been received. Tropical Marine Construction will be in touch shortly.',
            keywords: 'Tropical Marine Construction, Cape Coral, contact confirmation'
        },
        heroBg: ASSETS.DOCKS_1 || '',
        title: 'THANK YOU!',
        subtitle: 'Your message has been received. We will get back to you promptly to discuss your project.',

        nextStepsTitle: 'What Happens Next',
        nextStepsBody: 'Our team will review your inquiry and reach out to schedule a consultation. We provide free, written estimates for all dock construction, boat lift, repair, and maintenance projects in Cape Coral and Lee County.',

        meanwhile: 'While You Wait',
        galleryBtn: 'View Our Photo Gallery',
        homeBtn: 'Back to Home',

        projectsTitle: 'Our Marine Construction Services',
        projectsSub: 'Dock Construction, Boat Lift Installation, Repair, Maintenance, and Tiki Huts throughout SWFL.'
    }
};

function resolveLanguage(language) {
    return language === 'he' ? 'he' : 'en';
}

export function getThankYouData(language) {
    const lang = resolveLanguage(language);
    return ThankYouData[lang] || ThankYouData.en;
}

export default ThankYouData;
